<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px padding-left-10px">

        Select Material Availability

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body padding-top-0px padding-bottom-0px">



        <ul class="nav nav-tabs nav-tab-service2 margin-top-13px" id="tabContent">
          <li class="active margin-right-15px"><a class="nav-itemerp active" href="#Vendor" data-toggle="tab">Select Batch</a></li>
          <li class="margin-right-15px"><a class="nav-itemerp" href="#Material" data-toggle="tab" hidden>Modify</a></li>

        </ul>

        <div class="tab-content">
          <div class="tab-pane active" id="Vendor">
            <div class="card">
              <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-0px">
                <div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px">
                  <div class="col-md-4  text-align-center padding-right-0px padding-left-0px border-right-1px">
                    <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Material Name</h4></div>
                    <div class="margin-bottom-10px">
                    <h4 class="margin-bottom-0px display-inline color-Checkin font-weight-bold nav-link-hand"
                        *ngIf="MaterialName" (click)="EditMaterialDetails()">{{MaterialName}}</h4></div>
                  </div>
                  <div class="col-md-4  text-align-center padding-right-0px padding-left-0px border-right-1px">
                    <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Store Location</h4></div>
                    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Assign" *ngIf="StroreLocation">{{StroreLocation}}</h4></div>
                  </div>
                  <div class="col-md-4 text-align-center padding-right-0px padding-left-0px border-right-1px">
                    <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Consumption Group</h4></div>
                    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline" *ngIf="ConsumptionGroup">{{ConsumptionGroup}}</h4> </div>
                  </div>
                  <!--<div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
                    <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Required Qty</h4></div>
                    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-checkout"></h4></div>
                  </div>-->
                  <!--<div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
                    <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Item Name</h4></div>
                    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline"> Consultant</h4></div>
                  </div>
                  <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
                    <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Requst Qty</h4></div>
                    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline">2</h4></div>
                  </div>-->
                </div>
                <!--<div class="row">
                  <div class="col-md-12 padding-right-9px padding-left-10px">
                    <div class="row font-size-14 margin-top-10 margin-left-0px">
                      <div class="col-md-2">
                        <h4 class="margin-bottom-0px margin-top-3px">Selected Batch </h4>
                      </div>:
                      <div class="col-md-7  padding-left-10px my-profile-form">

                        <div class="form-group margin-bottom-0px">

                          <h4 class="margin-bottom-0px  margin-top-3px"></h4>


                        </div>


                      </div>

                    </div>
                  </div>

                </div>-->
                <div class="row padding-top-10px">
                  <div class="col-md-11 margin-left-15px">
                    <h4 class="margin-bottom-0px color-Assign font-size-14 font-weight-bold">Material Inventory</h4>
                  </div>
                  <div class="col-md-12" *ngIf="length>0">
                    <div class="chatsd product-chart-wrapper product-chat-height-335px agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                      <div class="table-component">
                        <div class="table-responsive overflow-x">


                          <table class="table table-striped margin-left-20p table-fixed"
                                 cols="auto,2*,*,*,*,*,*,*">

                            <thead class="">
                              <tr>
                                <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px text-align-center color-red">
                                  Hsn
                                </th>
                                <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px text-align-center">
                                  Batch
                                </th>
                                <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-2px">
                                  Supplier
                                </th>
                                <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-5px">
                                  Av.QTy
                                </th>
                                <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                                  Entry Date
                                </th>
                                <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                                  Expiry Date
                                </th>
                                <th class="padding-top-4px padding-bottom-4px th-sticky">
                                  Price
                                </th>
                                <th class="padding-top-4px padding-bottom-4px th-sticky">
                                  Req.QTY
                                </th>
                                <th class="padding-top-4px padding-bottom-4px th-sticky">

                                </th>
                              </tr>
                            </thead>

                            <tbody class="table-body">
                              <tr *ngFor="let l of CurrentMaterialBatchInaStoreController2;let i = index">
                                <td class="text-align-center td-padding-tb padding-right-0px padding-left-2px color-red">{{l.HsnCode}}</td>
                                <td class="text-align-center td-padding-tb padding-right-5px padding-left-2px">{{l.BatchNo}}</td>
                                <td class="text-align-left td-padding-tb padding-right-0px padding-left-0px">{{l.SupplierShortName}}</td>
                                <td class="text-align-right td-padding-tb ">{{l.AvailableQuantity}}</td>
                                <td class="td-padding-tb text-align-center padding-right-0px"> <label>{{l.EntryDate | date:'MMM-dd-yyyy'}}</label></td>


                                <!--<td *ngIf="IsNotExpired(l)" class="td-padding-tb text-align-center padding-right-0px">
                                  <label class="color-red">{{l.ExpiryDate | date:'MMM-dd-yyyy'}}</label>                       
                                </td>-->
                                <td class="td-padding-tb text-align-center padding-right-0px">
                                  <label *ngIf="IsNotExpired(l)">{{l.ExpiryDate | date:'MMM-dd-yyyy'}}</label>
                                  <a *ngIf="!IsNotExpired(l)" class="color-red">{{l.ExpiryDate | date:'MMM-dd-yyyy'}}</a>
                                </td>
                                <td class="text-align-right td-padding-tb ">{{l.SellingPrice | number:'1.0-2'}}</td>
                                <td class="text-align-center td-padding-tb">
                                  <!--<input type="number" class="form-control text-align-right td-width-82px" placeholder=""
                                  [(ngModel)]="l.quantity"
                                  maxlength="2" required>-->
                                  <!--<label *ngIf="!l.Edit" class="margin-bottom-0px">{{l.Quantity}}</label>-->
                                  <div>
                                    <input type="number" class="form-control text-align-right td-width-82px" placeholder=""
                                           [(ngModel)]="l.Quantity" (input)="IsQtyNotAvlbl(l)"
                                           maxlength="5" pattern="^[\0-9,._\-?]*$" #Endometrium="ngModel" required>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(only numbers are allowed)</small>
                                  </div>
                                </td>
                                
                                <td class=" td-padding-tb ">

                                  <!--<a class="nav-link-hand education-navlink font-size-16px color-Assign" title="Edit Plan" (click)="Editrow()" *ngIf="Add">
                                    <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                  </a>-->
                                  <!--<button type="submit" (click)="Editrow(l)" class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Save" *ngIf="!l.Edit"><i class="fas fa-pencil-alt"></i></button>-->
                                  <button
                                          *ngIf="IsNotExpired(l) && (l.Quantity > 0) && (l.Quantity <= l.AvailableQuantity)"
                                          type="button" class="btn font-size-13px actions-btn-prime" (click)="activeModal.close(l)">
                                    Select
                                  </button>
                                  <!--<button type="submit" (click)="OnClear(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l.Edit"><i class="far fa-save"></i></button>
                                  <button type="submit" (click)="OnClear(l)" class="button-service-save font-size-16px  nav-link-hand color-Rejected" title="Save" *ngIf="l.Edit"><i class="fa fa-times"></i></button>-->

                                </td>



                              </tr>
                            </tbody>



                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="length==0" class="margin-left-auto margin-right-auto">
                    <label class="margin-bottom-0px color-Assign font-size-18px">
                      Batches are not avilable for this Material. <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right">Raise Request</button>
                    </label>
                  </div>
                </div>
              </div>
              <!--<div class="card-footer text-align-center">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
              </div>-->
            </div>


          </div>

          <div class="tab-pane" id="Material">

            <form class="form" novalidate="" (ngSubmit)="Education()" #fm="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general padding-top-0px">

                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="firstName" class="margin-bottom-0px margin-top-3px">Material Name </label>
                                </div>:
                                <div class="col-md-3">

                                  <h4 class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold font-size-16px" *ngIf="MaterialName">{{MaterialName}}</h4>

                                </div>

                              </div>

                            </div>
                          </div>

                          <!--<div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Sell Unit </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Sell Unit"
                                         id="CurrentSaveMaterialDetailsInfoRequest.SellingUnit"
                                         [(ngModel)]="CurrentSaveMaterialDetailsInfoRequest.SellingUnit"
                                         name="CurrentSaveMaterialDetailsInfoRequest.SellingUnit" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" required #SellUnit="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!SellUnit.valid && (SellUnit.dirty || SellUnit.touched) && SellUnit.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!SellUnit.valid && SellUnit.errors.pattern)">(special characters are not allowed)</small>
                                </div>
                              </div>


                            </div>
                          </div>



                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Purchase Unit</label>
                                </div>

                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Purchase Unit"
                                         id="CurrentSaveMaterialDetailsInfoRequest.PurchaseUnit"
                                         [(ngModel)]="CurrentSaveMaterialDetailsInfoRequest.PurchaseUnit"
                                         name="CurrentSaveMaterialDetailsInfoRequest.PurchaseUnit" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" required #PrUnit="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!PrUnit.valid && (PrUnit.dirty || PrUnit.touched) && PrUnit.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!PrUnit.valid && PrUnit.errors.pattern)">(special characters are not allowed)</small>


                                </div>
                              </div>


                            </div>
                          </div>-->
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Hsn Code</label>
                                </div>

                                <div class="col-md-3" *ngIf="MaterialSpecData">
                                  <input type="text" class="form-control" placeholder="Hsn Code"
                                         id="MaterialSpecData.MaterialFormattedCode"
                                         [(ngModel)]="MaterialSpecData.MaterialFormattedCode"
                                         name="MaterialSpecData.MaterialFormattedCode" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" required #Hsncode="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Hsncode.valid && (Hsncode.dirty || Hsncode.touched) && Hsncode.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Hsncode.valid && Hsncode.errors.pattern)">(special characters are not allowed)</small>


                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Tax %</label>
                                </div>
                                <div class="col-md-3" *ngIf="MaterialSpecData">
                                  <CodeTypeValue CodeType="TAXPC" id="MaterialSpecData.TaxPercent"
                                                 [(ngModel)]="MaterialSpecData.TaxPercent" SelectedValue=""
                                                 name="MaterialSpecData.TaxPercentage">
                                  </CodeTypeValue>
                                  <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                                 [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                                 name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                                  </CodeTypeValue>-->
                                  <!--<input type="text" class="form-control" placeholder="Test"
                                         id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                         [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                         name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                         maxlength="100" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                  <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                           id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                           [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                           name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                                  </CustomDataByRequestType>-->
                                </div>

                              </div>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <!--<button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>-->
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px" [disabled]="!fm.form.valid" *ngIf='isvisiblem'>Save</button>
                </div>
              </div>

            </form>





          </div>




        </div>











      </div>



    </div>

  </div>
</div>


